
import React from 'react';
import { withRouter } from 'react-router-dom';
import Banner from './banner/Banner';
import Dashboard from './dashboard/Dashboard';
import Foot from './Foot';
import { StylesProvider } from '@material-ui/core/styles';
import { makeStyles, Container } from '@material-ui/core';
import qs from 'querystring';

const useStyles = makeStyles((theme) => ({
    container: {
        maxWidth: "100%",
        height: "inherit",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
    }
}))

function Home(props) {

    const { search } = props.location;
    const { Country, Lang } = qs.parse(search.slice(1));
    console.log(qs.parse(search.slice(1)));
    console.log(Lang);
    const year = new Date().getFullYear();
    const classes = useStyles();

    return (
        <StylesProvider>
            <Container className={classes.container} disableGutters={true}>
                {Lang ?
                    <>
                        <Banner Country={Country} Lang={Lang} />
                        <Dashboard Lang={Lang} Country={Country} />
                    </>
                    :
                    <>
                        <Banner Country={Country} Lang={''} />
                        <Dashboard Lang={""} Country={Country} />
                    </>
                }
                <Foot year={year} Lang={Lang} Country={Country} />
            </Container>
        </StylesProvider>
    );
}

export default withRouter(Home);